import React from 'react'
import ClosureSurvey from 'sprockets_react/closure_survey/registry'

ClosureSurvey.CloseModalWarning = function() {
  return(
    <div className="close-modal-warning" style={{display: 'none'}}>
      <p className="bold">Your feedback has NOT been saved! Are you sure you want to exit?</p>
      <div className="row">
        <div className="col-sm-6">
          <a href="#" className="btn btn-block btn-clear btn-white modal-exit">
            Exit
          </a>
        </div>
        <div className="col-sm-6">
          <a href="#" className="btn btn-block btn-white modal-stay" style={{color: 'red'}}>
            Stay & Continue
          </a>
        </div>
      </div>
    </div>
  )
}
